<template>
  <div class="TaskCenter">
    <el-dialog
      title="任务中心"
      width="70%"
      :visible.sync="dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
    >
      <TaskList ref="TaskList" />
    </el-dialog>
  </div>
</template>

<script>
import TaskList from './task-list/index.vue'
import { mapState } from 'vuex'
export default {
  name: 'TaskCenter',
  components: { TaskList },
  computed: {
    ...mapState({
      dialogVisible: state => state.user.taskDialogVisi
    })
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.TaskList.getData()
        })
      }
    }
  },
  methods: {
    close() {
      this.$store.commit('user/SET_TASK_DIALOG_VISI', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
